/* eslint-disable no-underscore-dangle */
import jwtDecode from 'jwt-decode';

const g = global as any;

const resolveTokenFromWindow = () => (g.__auth && g.__auth.refresh) ? g.__auth.refresh : null;
const resolveTokenFromUrl = () => (new URLSearchParams(window.location.search)).get('login') || null;
const resolveTokenFromLocalStorage = () => localStorage.getItem('deqo.login') || null;

export interface SecurityToken {
    readonly value: string;
}

export class ApiRefreshToken implements SecurityToken {

    public static resolve() {

        try {
            const value =
                resolveTokenFromWindow() ??
                resolveTokenFromUrl() ??
                resolveTokenFromLocalStorage();

            if (value) {
                jwtDecode(value);
                localStorage.setItem('deqo.login', value);
                return new ApiRefreshToken(value);
            }
        }
        catch {
            // u wot eslint?
        }

        localStorage.removeItem('deqo.login');
        return null;
    }

    constructor(public readonly value: string) {
    }
}
